import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import _ from "lodash";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
import beneficiary from "../../gql/beneficiary";
import InsurancePlans from "../Beneficiary/components/InsurancePlans";
import SubscriberDetails from "../Beneficiary/components/SubscriberDetails";
import { useNavigate } from "react-router-dom";
import { Button, CircularProgress } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import eligibility from "../../gql/eligibility";
import AddIcon from "@mui/icons-material/Add";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { useTranslation } from "react-i18next";

function removeSpecialCharacters(input) {
  return input.replace(/(\d+-|\-[a-zA-Z])|[^a-zA-Z\s]/g, "");
}

function HelpDeskAddBene({
  item,
  chiReqRecord,
  setChiReqRecord,
  refetchGetById,
  systemType,
  eligibilityId,
  setEligibilityId,
}) {
  const { t } = useTranslation();
  const [addAddress, setAddAddress] = useState(false);
  const [isFormReset, setIsFormReset] = useState(false);
  const [payers, setPayers] = useState([]);
  const [submitEligibility, setSubmitEligibility] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const currentDate = new Date();

  const [fromDate, setFromDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
      2,
      "0",
    )}-01`,
  );
  const [toDate, setToDate] = useState(
    `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
      2,
      "0",
    )}-${new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0,
    ).getDate()}`,
  );

  const navigate = useNavigate();

  const [
    checkEligibility,
    { data: eligibilityData, loading: loadingData, error: errorData },
  ] = useMutation(eligibility.ELIGIBILITY_CHECK, {
    update(proxy, result) {
      toast.success(t("Data send to payer successfully!"));
      setEligibilityId(result.data.verificationRequest.transaction_id);
      onSuccessfulEligibilityRequestResponse(result.data);
    },
    onError(error) {
      onEligibilityResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulEligibilityRequestResponse = (data) => {
    if (!data.verificationRequest.nphies_err) {
      setShowLoader(false);
    } else {
      setShowLoader(false);
    }
  };

  const onEligibilityResponseError = (error) => {
    setShowLoader(false);

    toast.error(`${error?.message}`);
  };

  const [patientId, setPatientId] = useState(item ? item.id : null);
  const gender = [
    { id: "male", name: t("Male") },
    { id: "female", name: t("Female") },
    { id: "unknown", name: t("Unknown") },
  ];

  const xdocumentTypes = [
    { id: "iqama", name: t("Iqama") },
    { id: "Resident Card", name: t("Resident Card") },
    { id: "Passport", name: t("Passport") },
    { id: "Visa", name: t("Visa") },
    { id: "National Card", name: t("National Card") },
    { id: "Medical Record Number", name: t("Medical Record Number") },
  ];

  const documentTypes = [
    { id: "VP", name: t("VISA") },
    { id: "PPN", name: t("Passport") },
    { id: "PRC", name: t("Permanent Resident Card Number") },
    { id: "MR", name: t("Medical record number") },
    { id: "NI", name: t("National Card") },
  ];

  const nationalities = [
    { id: "Saudi Arabia", name: t("Saudi Arabia") },
    { id: "Afghanistan", name: t("Afghanistan") },
    { id: "Albania", name: t("Albania") },
    { id: "Aland Islands", name: t("Aland Islands") },
  ];

  const residencyTypes = [
    { id: "iqama", name: t("Iqama") },
    { id: "visa", name: t("Visitor") },
    { id: "nationalId", name: t("Citizen or Resident") },
  ];

  const maritalStatuses = [
    { id: "D", name: t("Divorced") },
    { id: "L", name: t("Legally Separated") },
    { id: "M", name: t("Married") },
    { id: "U", name: t("Unmarried") },
    { id: "W", name: t("Widowed") },
  ];
  const occupationOptions = [
    { id: "administration", name: t("Administration") },
    { id: "agriculture", name: t("Agriculture") },
    { id: "business", name: t("Business") },
    { id: "education", name: t("Education") },
    { id: "housewife", name: t("Housewife") },
    { id: "marine", name: t("Marine") },
    { id: "medical field", name: t("Medical Field") },
    { id: "military", name: t("Military") },
    { id: "skilled worker", name: t("Skilled Worker") },
    { id: "student", name: t("Student") },
    { id: "oil industries", name: t("Oil Industries") },
    { id: "unemployed", name: t("Unemployed") },
    { id: "others", name: t("Others") },
    { id: "unknown", name: t("Unknown") },
  ];
  const religionOptions = [
    { id: "1", name: t("Muslim") },
    { id: "2", name: t("Christian") },
    { id: "3", name: t("Judaism") },
    { id: "4", name: t("Buddhism") },
    { id: "5", name: t("Zoroastrian") },
    { id: "7", name: t("Hinduism") },
    { id: "8", name: t("Sikh") },
    { id: "9", name: t("Without") },
    { id: "98", name: t("Not available") },
    { id: "99", name: t("Not mentioned") },
    { id: "0", name: t("Other") },
  ];

  const bloodGroups = [
    { id: "O+", name: "O+" },
    { id: "O-", name: "O-" },
    { id: "A+", name: "A+" },
    { id: "A-", name: "A-" },
    { id: "B+", name: "B+" },
    { id: "B-", name: "B-" },
  ];

  const visaType = [
    { id: 6, name_ar: "مرور", name_en: t("Transit") },
    {
      id: 10,
      name_ar: "سياحية او سياحية - هيا",
      name_en: t("Tourism or Tourist - Haya"),
    },
    { id: 14, name_ar: "توصيل بضائع", name_en: t("Cargo Delivery") },
    { id: 23, name_ar: "زيارة تجارية", name_en: t("Business Visit") },
    { id: 24, name_ar: "زيارة عائلية", name_en: t("Family Visit") },
    { id: 21, name_ar: "رجال اعمال", name_en: t("Businessmen") },
    { id: 22, name_ar: "زيارة عمل", name_en: t("Work Visit") },
    { id: 27, name_ar: "زيارة شخصية", name_en: t("Personal Visit") },
    { id: 40, name_ar: "مرافق", name_en: t("Accompanying") },
    { id: 30, name_ar: "زيارة فعالية", name_en: t("Event Visit") },
  ];

  const tableHeaders = [
    {
      name: "House No./ Apartment",
    },
    {
      name: "Street Name",
    },
    {
      name: "City",
    },
    {
      name: "State/Province",
    },
    {
      name: "Country",
    },
    {
      name: "Postal Code",
    },
  ];

  const onSuccessfulRequestResponse = (data) => {
    if (data.registerPatient) {
      toast.success("Successfully Added!");
      formik.resetForm();
      setChiReqRecord(null);
      setIsFormReset(true);
      setPatientId(data.registerPatient.data.id);
    } else {
    }
  };

  const onResponseError = (error) => {
    if (error?.message) {
      toast.error(`${error?.message}`);
    }
  };

  const [createPatient, { data, loading, error }] = useMutation(
    beneficiary.CREATE_PATIENT,
    {
      update(proxy, result) {
        onSuccessfulRequestResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );

  const [
    editBeneficiary,
    { updatedData, loading: updatedLoading, updatedError },
  ] = useMutation(beneficiary.UPDATE_BENEFICIARY, {
    update(proxy, result) {
      onSuccessfulEditResponse(result.data);
    },
    onError(error) {
      onResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulEditResponse = (data) => {
    if (data?.updatePatient) {
      toast.success(data?.updatePatient?.message || "Update Successfully!");
      formik.resetForm();
      setChiReqRecord(null);
      setIsFormReset(true);
      navigate("/eligibility");
      // refetch();
    } else {
    }
  };

  useEffect(() => {
    if (error?.graphQLErrors[0]?.message) {
      toast.error(error?.graphQLErrors[0]?.message);
    }
    if (updatedError?.graphQLErrors[0]?.message) {
      toast.error(updatedError?.graphQLErrors[0]?.message);
    }
  }, [error, updatedError]);

  const formatInputData = (postData) => {
    return {
      start_date: currentDate.toISOString().substring(0, 10),
      end_date: currentDate.toISOString().substring(0, 10),
      payer_id: `${
        postData?.insurance_plans?.length > 0 &&
        postData?.insurance_plans[0]?.payer_id
      }`,
      patient_id: postData?.id,
      insurance_plan_id: `${
        postData?.insurance_plans?.length > 0 &&
        postData?.insurance_plans[0]?.id
      }`,
      purpose: ["benefits", "validation", "discovery"],
      is_new_born: false,
      is_referral: false,
    };
  };

  const addData = (values) => {
    let data = _.cloneDeep(values);

    if (item) {
      data["id"] = item.id;

      if (data?.insurance_plans) {
        data.insurance_plans = data.insurance_plans.map((plan) => {
          const { payer, ...rest } = plan;
          return rest;
        });
      }
      delete data.beneficiary_file_id;

      editBeneficiary({ variables: { input: data } }).then((res) => {
        refetchGetById();
        if (submitEligibility) {
          toast.loading(t("Checking Eligibility"));
          checkEligibility({
            variables: {
              input: formatInputData(values),
            },
          });
        }
      });
    } else {
      delete data.beneficiary_file_id;
      createPatient({ variables: { input: data } }).then((res) => {
        if (submitEligibility) {
          toast.loading(t("Checking Eligibility"));
          checkEligibility({
            variables: {
              input: formatInputData(res?.data?.registerPatient?.data),
            },
          });
        }
      });
    }
  };

  const inValidBtn = (values) => {
    if (!values.is_new_born && values.insurance_plans.length < 1) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (chiReqRecord) {
      formik.resetForm();
      if (systemType === "5") {
        formik.setFieldValue(
          "full_name",
          chiReqRecord?.Insurance[0]?.InsuredName ||
            chiReqRecord?.Insurance[0]?.NAME ||
            chiReqRecord?.Insurance[0]?.Name ||
            "",
        );
        formik.setFieldValue(
          "document_id",
          chiReqRecord?.Insurance[0]?.PassportNumber || "",
        );
        formik.setFieldValue("document_type", "PPN");

        formik.setFieldValue(
          "contact_number",
          chiReqRecord?.Insurance[0]?.MobileNumber || "",
        );
        formik.setFieldValue(
          "dob",
          chiReqRecord?.Insurance[0]?.DateOfBirth || "",
        );

        formik.setFieldValue(
          "gender",
          chiReqRecord?.Insurance[0]?.Gender == 1
            ? "male"
            : chiReqRecord?.Insurance[0]?.Gender == 2
              ? "female"
              : chiReqRecord?.Insurance[0]?.Gender == 3
                ? "unknown"
                : "other" || "",
        );
      } else {
        formik.setFieldValue(
          "full_name",
          chiReqRecord?.Insurance[0]?.Name ||
            chiReqRecord?.Insurance[0]?.NAME ||
            "",
        );
        formik.setFieldValue(
          "document_id",
          chiReqRecord?.Insurance[0]?.IdentityNumber ||
            chiReqRecord?.Insurance[0]?.IDENTITYNUMBER ||
            "",
        );

        formik.setFieldValue(
          "gender",
          chiReqRecord?.Insurance[0]?.Gender == 1
            ? "male"
            : chiReqRecord?.Insurance[0]?.Gender == 2
              ? "female"
              : chiReqRecord?.Insurance[0]?.Gender == 3
                ? "unknown"
                : "other" || "",
        );
      }
      if (systemType === "5") {
        const insuranceArray = chiReqRecord.Insurance.map(async (insurance) => {
          let payerId = "";

          return {
            member_card_id: "",
            policy_number: insurance.PolicyNumber || "",
            expiry_date: "",
            is_primary: true,
            payer_id: payerId,
            relation_with_subscriber: "self",
            patient_share: "0.00",
            max_limit: 0,
            network: "",
            issue_date: "",
            sponsor_no: "",
            policy_class_type: "",
            policy_holder: "",
            insurance_type: "",
            insurance_status: "",
            insurance_duration: "",
            policy_class_name: "",
            coverage_type: "Extended Healthcare",
            policy_class_id: "",
          };
        });

        // Wait for all promises to resolve
        Promise.all(insuranceArray).then((resolvedInsuranceArray) => {
          formik.setFieldValue("insurance_plans", resolvedInsuranceArray);
        });
      } else {
        const insuranceArray = chiReqRecord.Insurance.map(async (insurance) => {
          let payerId = "";

          if (payers?.length > 0) {
            for (const tpa of payers) {
              const payer = await tpa?.payers?.find((payer) => {
                const nameENWithoutAsterisk = payer?.name_en.replace(/\*/g, "");
                const nameARWithoutAsterisk = payer?.name_ar.replace(/\*/g, "");
                return (
                  _.includes(
                    nameARWithoutAsterisk,
                    insurance?.InsuranceCompanyAR || insurance?.ArabicICName,
                  ) ||
                  _.includes(
                    nameENWithoutAsterisk,
                    insurance?.InsuranceCompanyEN ||
                      insurance?.InsuranceCompany,
                  )
                );
              });

              if (payer) {
                payerId = payer.id || "";
                break;
              }
            }
          }

          return {
            member_card_id: insurance.BeneficiaryNumber || "",
            policy_number: insurance.PolicyNumber || "",
            expiry_date: insurance.ExpiryDate || "",
            is_primary: true,
            payer_id: payerId,
            relation_with_subscriber: "self",
            patient_share: insurance.DeductibleRate || "0.00",
            max_limit: +insurance.MaxLimit || 0,
            network: insurance.NetworkID || "",
            issue_date: insurance.IssueDate || insurance.ISSUEDATE || "",
            sponsor_no: insurance.SponsorNumber || "",
            policy_class_type: "plan",
            policy_holder: insurance.PolicyHolder || "",
            insurance_type: "",
            insurance_status: "",
            insurance_duration: "",
            policy_class_name: "",
            coverage_type: "Extended Healthcare",
            policy_class_id: insurance.ClassName || "",
          };
        });

        Promise.all(insuranceArray).then((resolvedInsuranceArray) => {
          formik.setFieldValue("insurance_plans", resolvedInsuranceArray);
        });
      }
    }
  }, [chiReqRecord]);

  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(currentDate.getMonth() - 3);

  const formik = useFormik({
    initialValues: {
      first_name: item?.first_name
        ? item.first_name
        : chiReqRecord
          ? chiReqRecord?.Insurance[0]?.Name || chiReqRecord?.Insurance[0]?.NAME
          : "",
      middle_name: item?.middle_name ? item.middle_name : "",
      last_name: item?.last_name ? item.last_name : "",
      family_name: item?.family_name ? item.family_name : "",
      full_name: item?.full_name
        ? item.full_name
        : chiReqRecord
          ? chiReqRecord?.Insurance[0]?.Name || chiReqRecord?.Insurance[0]?.NAME
          : "",
      file_no: item?.file_no ? item.file_no : "",
      dob: item?.dob ? item.dob : threeMonthsAgo.toISOString().substring(0, 10),
      gender: item?.gender
        ? item.gender
        : chiReqRecord
          ? chiReqRecord?.Insurance[0]?.Gender == 1
            ? "male"
            : chiReqRecord?.Insurance[0]?.Gender == 2
              ? "female"
              : chiReqRecord?.Insurance[0]?.Gender == 3
                ? "unknown"
                : "other"
          : "",
      document_type: item?.document_type ? item.document_type : "",
      document_id: item?.document_id
        ? item.document_id
        : chiReqRecord
          ? chiReqRecord?.Insurance[0]?.IdentityNumber ||
            chiReqRecord?.Insurance[0]?.IDENTITYNUMBER
          : "",
      nphies_id: item?.nphies_id ? item.nphies_id : "",
      eHealth_id: item?.eHealth_id ? item.eHealth_id : "",
      nationality: item?.nationality ? item.nationality : "",
      residency_type: item?.residency_type ? item.residency_type : "",
      contact_number: item?.contact_number ? item.contact_number : "",
      blood_group: item?.blood_group ? item.blood_group : "",
      preferred_language: item?.preferred_language
        ? item.preferred_language
        : "",
      emergency_number: item?.emergency_number ? item.emergency_number : "",
      email: item?.email ? item.email : "",
      is_new_born: item?.is_new_born ? item.is_new_born : false,
      street_line: item?.street_line ? item.street_line : "",
      address_line: item?.address_line ? item.address_line : "",
      city: item?.city ? item.city : "",
      state: item?.state ? item.state : "",
      country: item?.country ? item.country : "",
      postal_code: item?.postal_code ? item.postal_code : "",
      subscriber_id: item?.subscriber_id ? item.subscriber_id : "",
      subscriber_relationship: item?.subscriber_relationship
        ? item.subscriber_relationship
        : "",
      subscriber_insurance_plan: item?.subscriber_insurance_plan
        ? item.subscriber_insurance_plan
        : "",
      insurance_plans: item?.insurance_plans ? item.insurance_plans : [],
      passport_no: item?.passport_no ? item.passport_no : "",
      visa_no: item?.visa_no ? item.visa_no : "",
      visa_title: item?.visa_title ? item.visa_title : "",
      visa_type: item?.visa_type ? item.visa_type : "",
      border_no: item?.border_no ? item.border_no : "",
      insurance_duration: item?.insurance_duration
        ? item.insurance_duration
        : "",
      id: item?.id ? item.id : "",

      // yyy
      martial_status: item?.martial_status ? item.martial_status : "U",
      occupation: item?.occupation ? item.occupation : "others",
      religion: item?.religion ? item.religion : "1",
    },
    enableReinitialize: true,

    validationSchema: () => {
      return Yup.object().shape({
        full_name: Yup.string().required(t("Full Name is required")),
        file_no: Yup.string(),
        dob: Yup.date()
          .nullable()
          .required(t("Dob is required"))
          .max(new Date(), t("Dob cannot be in the future"))
          .typeError(t("Please enter a valid date")),
        gender: Yup.string().required(t("Gender is required")),
        document_type: Yup.string().required(t("Document Type is required")),
        document_id: Yup.string().required(t("Document id is required")),
        insurance_plans: Yup.array().of(
          Yup.object().shape({
            member_card_id: Yup.string().required(
              t("Member Card ID is required"),
            ),
            policy_number: Yup.string().required(
              t("Policy number is required"),
            ),
            expiry_date: Yup.date().required(t("Expiry date is required")),
            issue_date: Yup.string().required(t("Issue Date is required")),
            is_primary: Yup.boolean().required(t("Is primary is required")),
            payer_id: Yup.string().required(t("Payer ID is required")),
            max_limit: Yup.number().required(t("Max Limit is required")),
            relation_with_subscriber: Yup.string().required(
              t("Relation with subscriber is required"),
            ),

            // yyy
            policy_holder: Yup.string().required(
              t("Policy Holder is required"),
            ),
            policy_class_type: Yup.string().required(
              t("Class Type is required"),
            ),
            policy_class_id: Yup.string().required(t("Class ID is required")),
          }),
        ),
        residency_type: Yup.string().required(t("Residency type is required")),
        passport_no: Yup.number(),
        visa_no: Yup.number(),
        visa_title: Yup.string(),
        visa_type: Yup.number(),
        border_no: Yup.number(),
        insurance_duration: Yup.string(),
        // yyy
        martial_status: Yup.string().required(t("Marital Status is required")),
        occupation: Yup.string().required(t("Occupation is required")),
      });
    },

    onSubmit: (values, { setSubmitting }) => {
      if (removeSpecialCharacters(values.full_name).trim() === "") {
        toast.error(t("invalid name"));
        return;
      }
      console.log({
        ...values,
        full_name: removeSpecialCharacters(values.full_name),
        first_name: removeSpecialCharacters(
          values.first_name || values.full_name,
        ),
      });

      addData({
        ...values,
        full_name: removeSpecialCharacters(values.full_name),
        first_name: removeSpecialCharacters(
          values.first_name || values.full_name,
        ),
      });
    },
  });

  useEffect(() => {
    if (formik.values?.document_id?.length > 0) {
      if (formik.values?.document_id[0] == 1) {
        formik.setFieldValue("document_type", "NI");
        formik.setFieldValue("residency_type", "nationalId");
      } else if (formik.values?.document_id[0] == 2) {
        formik.setFieldValue("document_type", "PRC");
        formik.setFieldValue("residency_type", "iqama");
      } else if (formik.values?.document_id[0] == 4) {
        formik.setFieldValue("document_type", "VP");
        formik.setFieldValue("residency_type", "visa");
      }
    }
  }, [formik.values?.document_id, chiReqRecord]);

  React.useEffect(() => {
    const payersData = JSON.parse(localStorage.getItem("payersData"));

    if (payersData && payersData.length > 0) {
      setPayers(payersData);
    } else {
      navigate("/dashboard");
    }
  }, []);

  useEffect(() => {
    if (chiReqRecord) {
      setTimeout(() => {
        formik.handleSubmit();
      }, 200);
    }
  }, [chiReqRecord]);
  return (
    <>
      <div className=" flex gap-3 justify-center">
        {/* {chiReqRecord && (
          <Button
            variant='contained'
            onClick={() => {
              setSubmitEligibility(true)
              formik.handleSubmit()
            }}
            className=' disabled:!text-white'
            style={{
              backgroundImage:
                'linear-gradient(83deg, #f14f3e 25%, #0070C2 100%)'
            }}
            startIcon={
              loadingData ? (
                <CircularProgress size={20} color='inherit' />
              ) : (
                <DoneAllIcon />
              )
            }
            size='small'
            disabled={loadingData}
          >
            {loadingData
              ? ` ${t(' Checking Eligibility')}`
              : `${t('Check Eligibility')}`}
          </Button>
        )} */}
      </div>
    </>
  );
}

export default HelpDeskAddBene;
